
declare global {
  interface String {
    replaceAllText(search: string, replacement: string): string;
    to1stCharCapital(): string;
    removeUTCCharacters(): Date;
    toBool(): boolean;
  }
}

String.prototype.replaceAllText = function(search: string, replacement: string): string {
  return this.split(search).join(replacement);
};

String.prototype.to1stCharCapital = function(): string {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.removeUTCCharacters = function(): Date {
  return new Date(this.toString().replace('UTC', ''));
};

String.prototype.toBool = function(): boolean {
  return this.toLowerCase() === 'true';
};

export {};